module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","setDate"],"commonjs":"date-fns/set_date/index","commonjs2":"date-fns/set_date/index","amd":"date-fns/set_date/index"}
// module id = 48
// module chunks = 0